<template>
  <!-- 智慧校园 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        <div class="img_wrap" v-for=" (item, index) in pageData.imgArr" :key="index">
          <img :src="item.imgSrc" :alt="item.alt">
        </div>
        &nbsp;
        <div class="article_box unify_article">{{pageData.text.text2}}</div>
        &nbsp;
        <div class="article_wrap">
          <div class="subtitle">{{pageData.text.text3.textTitle}}</div>
          <div class="text unify_article">{{pageData.text.text3.textContent}}</div>
        </div>
         &nbsp;
        <div class="article_wrap">
          <div class="subtitle">{{pageData.text.text4.textTitle}}</div>
          <div class="text unify_article">{{pageData.text.text4.textContent}}</div>
        </div>
        &nbsp;
        <div class="article_wrap">
          <div class="subtitle">{{pageData.text.text5.textTitle}}</div>
          <div class="text unify_article">{{pageData.text.text5.textContent}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: '智慧校园',
          text: {
            text1: '瑞谦智慧校园解决方案以校园安全为核心，运用视频识别分析、物联网、大数据等技术，结合视频监控、校园出入口管理、周界安防等系统，构建具有丰富的报警联动功能的校园智慧安防，同时将学校教学、管理、生活等事务以及各类校园资源和应用系统高效整合，全面高效地对校园人、事、物进行统一管理，建设智慧化管理和智慧化服务的新型安全校园。',
            text2: '主要从智慧教学、智慧管理、校园服务、校园安全4个方面建设智慧校园。',
            text3: {
              textTitle: '智慧教学',
              textContent: '构建先进实用的网络教学平台，整合、丰富智慧教学资源，建设新型现代化智慧教室，创造主动式、协同式的学习环境，建立师生互动的新型教学模式，提高教学效果。'
            },
            text4: {
              textTitle: '智慧管理',
              textContent: '构建考勤管理、宿舍管理、OA办公系统等覆盖全校工作流程，管理体系，实现管理的科学化、自动化、精细化，突出以人为本的理念，提高管理效率，降低管理成本。'
            },
            text5: {
              textTitle: '校园服务',
              textContent: '建设智慧图书馆、智慧班牌，丰富学生课余信息供给；教室内、外环境进行监测的应用，为师生提供绿色的校园学习、生活环境。'
            },
            text6: {
              textTitle: '校园安全',
              textContent:'以人脸识别技术为基础，结合视频监控系统、周界安防系统等，构建具有丰富的报警联动功能的智慧安防，全方面对校园安全进行实时监控和预防，极大减少校园安全事故，提升学校的安全管理水平。'
            }
          },
          imgArr: [
            {
              imgSrc: require('@/assets/img/solution/pageImg/2.jpg'),
              alt: ''
            }
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
</style>
